import React, { useEffect, useState } from 'react';
import './style/PaymentSuccess.css';
import { useParams, Link } from 'react-router-dom';
import TopNavbar from '../home/TopNavbar';

const PaymentSuccessFail = () => {
  const { payment_id } = useParams();
  const [isAnimating, setIsAnimating] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAnimating(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Function to handle clipboard copy
  const handleCopy = async () => {
    if (!payment_id) return;
    try {
      await navigator.clipboard.writeText(payment_id);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset button text after 2 seconds
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="payment-success-container warning-state">

      <TopNavbar name="Action Required" ></TopNavbar>

      <div className="success-card">
        
        {/* Animated Warning Exclamation Icon */}
        <div className={`checkmark-container warning-icon ${isAnimating ? 'animating' : ''}`}>
          <svg 
            className="checkmark" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 52 52"
          > 
            <circle 
              className="checkmark__circle warning-circle" 
              cx="26" 
              cy="26" 
              r="25" 
              fill="none"
            />
            <path 
              className="checkmark__check" 
              fill="none" 
              strokeWidth="5"
              strokeLinecap="round"
              d="M26 14 v16 M26 38 h0.1"
            />
          </svg>
        </div>

        <div className="success-content">
          <h1 className="success-title warning-title">Payment Received, Action Required</h1>
          
          {/* Payment ID Badge with Copy Button */}
          <div className="payment-id-badge-container">
            <div className="payment-id-badge">
              <span>Payment ID:</span> <p>{payment_id || "N/A"}</p>
            </div>
            {payment_id && (
              <button 
                onClick={handleCopy} 
                className={`copy-btn ${copied ? 'copied' : ''}`}
                aria-label="Copy Payment ID"
              >
                {copied ? 'Copied!' : 'Copy'}
              </button>
            )}
          </div>

          <p className="success-message">
            Your payment was successful, but we encountered a technical issue while updating your account details. 
          </p>
          
          <blockquote>
            <strong>Important:</strong> Please copy the Payment ID above, head over to our support page, and submit it so our team can manually activate your features right away.
          </blockquote>
        </div>

        <div className="additional-info">
          <div className="action-buttons">
            <Link to="/contact" className="btn btn-primary">
              Contact Support Now
            </Link>
          </div>
          
          <div className="support-info">
            <span>Need immediate help? </span>
            <Link to="/contact" className="support-link">Get in Touch</Link>
          </div>
        </div>  <br></br><br></br>

      </div>
    </div>
  );
};

export default PaymentSuccessFail;